import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/workStyle.js";

const useStyles = makeStyles(styles);

export default function WorkSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem cs={12} sm={12} md={8}>
          <h2 className={classes.title}>Connect with me</h2>
          <h5 className={classes.title}>
            Email me at:{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              color="rose"
              href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=mehrotra.rachit.io@gmail.com"
            >
              mehrotra.rachit.io@gmail.com
            </a>
          </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}
